import { alpha, Box, Grid, styled, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import CustomContainer from "../../../container";
import Banners from "../../banners";
import BestReviewedItems from "../../best-reviewed-items";
import FeaturedCategories from "../../featured-categories";
import RunningCampaigns from "../../running-campaigns";
import Stores from "../../stores";
import VisitAgain from "../../visit-again";
import FeaturedStores from "./featured-stores";
import PharmacyStaticBanners from "./pharmacy-banners/PharmacyStaticBanners";
import CommonConditions from "./common-conditions";
import useGetOtherBanners from "../../../../api-manage/hooks/react-query/useGetOtherBanners";
import OrderDetailsModal from "../../../order-details-modal/OrderDetailsModal";
import { useSelector } from "react-redux";
import { getToken } from "../../../../helper-functions/getToken";
import { getCurrentModuleId } from "../../../../helper-functions/getCurrentModuleType";

const menus = ["All", "New", "Baby Care", "Womans Care", "Mens"];

const SectionWrapper = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.down("sm")]: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

const HeroSection = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
}));

const ContentSection = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(5),
  backgroundColor: theme.palette.mode === 'dark' 
    ? alpha(theme.palette.background.paper, 0.3)
    : alpha(theme.palette.primary.main, 0.02),
  borderRadius: "24px",
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    borderRadius: "16px",
  },
}));

const Pharmacy = ({ configData }) => {
  const theme = useTheme();
  const token = getToken();
  const { orderDetailsModalOpen } = useSelector((state) => state.utilsData);
  const { data, refetch, isLoading } = useGetOtherBanners();
  useEffect(() => {
    refetch();
  }, []);
  const visitedStores = localStorage.getItem("visitedStores")
    ? JSON.parse(localStorage.getItem("visitedStores"))?.length > 0
      ? JSON.parse(localStorage.getItem("visitedStores"))?.filter(
          (item) => item?.module_id === getCurrentModuleId()
        )
      : []
    : [];
  return (
    <Box sx={{ width: "100%", backgroundColor: theme.palette.background.default }}>
      <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
        {/* HERO SECTION - Featured Categories */}
        <Grid item xs={12}>
          <HeroSection>
            <CustomContainer>
              <FeaturedCategories configData={configData} />
            </CustomContainer>
          </HeroSection>
        </Grid>

        {/* BANNERS SECTION */}
        <Grid item xs={12}>
          <SectionWrapper>
            <CustomContainer>
              <PharmacyStaticBanners />
            </CustomContainer>
          </SectionWrapper>
        </Grid>

        {/* QUICK ACCESS SECTION - Visit Again */}
        <Grid item xs={12}>
          <SectionWrapper>
            <CustomContainer>
              <VisitAgain configData={configData} visitedStores={visitedStores} />
            </CustomContainer>
          </SectionWrapper>
        </Grid>

        {/* BASIC MEDICINE SECTION */}
        <Grid item xs={12}>
          <ContentSection>
            <CustomContainer>
              <BestReviewedItems
                menus={menus}
                title="Basic Medicine Nearby"
                bannerIsLoading={isLoading}
                url={`${data?.promotional_banner_url}/${data?.basic_section_nearby}`}
              />
            </CustomContainer>
          </ContentSection>
        </Grid>

        {/* PROMOTIONAL BANNERS SECTION */}
        <Grid item xs={12}>
          <SectionWrapper>
            <CustomContainer>
              <Banners />
            </CustomContainer>
          </SectionWrapper>
        </Grid>

        {/* FEATURED STORES SECTION */}
        <Grid item xs={12}>
          <ContentSection>
            <CustomContainer>
              <FeaturedStores title="Featured Store" configData={configData} />
            </CustomContainer>
          </ContentSection>
        </Grid>

        {/* RUNNING CAMPAIGNS SECTION */}
        <Grid item xs={12}>
          <SectionWrapper>
            <CustomContainer>
              <RunningCampaigns />
            </CustomContainer>
          </SectionWrapper>
        </Grid>

        {/* COMMON CONDITIONS SECTION */}
        <Grid item xs={12}>
          <ContentSection>
            <CustomContainer>
              <CommonConditions title="Common Conditions" />
            </CustomContainer>
          </ContentSection>
        </Grid>

        {/* ALL STORES SECTION */}
        <Grid
          item
          xs={12}
          sx={{
            position: "sticky",
            top: { xs: "47px", md: "92px" },
            zIndex: 999,
          }}
        >
          <SectionWrapper sx={{ paddingBottom: { xs: 4, md: 6 } }}>
            <CustomContainer>
              <Stores />
            </CustomContainer>
          </SectionWrapper>
        </Grid>
      {orderDetailsModalOpen && !token && (
        <OrderDetailsModal orderDetailsModalOpen={orderDetailsModalOpen} />
      )}
      </Grid>
    </Box>
  );
};

Pharmacy.propTypes = {};

export default Pharmacy;
